import React from "react";

// ParentRoutercontext is a context to pass the history and match objects from
// top level Router down to consumers. Within each page's routes, since we're
// using hash router in sub routes, they don't have access to the history object.
// This is useful to use `this.props.parentHistory.push('/someotherpage')`
export const ParentRouterContext = React.createContext({
  history: {},
  match: {},
});

// A helper Higher Order Component (HOC) used to wrap components
// so they have access to parentRouter and parentHistory. Wrap the
// consumer component with this HOC to have access to this.props.parentHistory
// and this.props.parentMatch objects.
export function withParentRouterContext(WrappedComponent) {
  return (props) => (
    <ParentRouterContext.Consumer>
      {(value) => (
        <WrappedComponent
          {...props}
          parentHistory={value.history}
          parentRouteMatch={value.match}
        />
      )}
    </ParentRouterContext.Consumer>
  );
}
